/**
 * Utility functions for Sentry logging
 */

/**
 * Converts an array of image URLs into an object with indexed keys
 * @param imageUrls - Array of image URL strings
 * @returns Object with keys like { image_0: 'url1', image_1: 'url2', ... }
 */
export const formatImageUrlsForSentry = (
  imageUrls?: Array<string>
): Record<string, string> => {
  if (!imageUrls || imageUrls.length === 0) {
    return {};
  }

  const imageObject: Record<string, string> = {};
  imageUrls.forEach((url, index) => {
    imageObject[`image_${index}`] = url;
  });

  return imageObject;
};

